// Should stay in sync with appraiserEventType.mjs

export const APPRAISER_EVENT_TYPE = {
  REGULAR: 1,
  DIRECT_CHANNEL: 2
};
